import type { ReactNode } from 'react'

interface PageHeadingProps {
  title: string
  /** What the page shows, after a thin divider on the title's line (wraps under it when narrow). */
  description?: string
  /** Right-aligned actions (search, buttons). */
  actions?: ReactNode
}

/**
 * A page's title line, as cgt-frontend's PageHeading (z8nrz7fv5m): the title,
 * then the description on the same baseline, so the description reads as a
 * continuation of the title rather than a label floating above it.
 */
export function PageHeading({ title, description, actions }: PageHeadingProps) {
  return (
    <header className="flex flex-wrap items-center justify-between gap-x-6 gap-y-3">
      <div className="flex min-w-0 flex-1 flex-wrap items-baseline gap-x-3 gap-y-1">
        <h1 className="text-2xl font-semibold leading-8 tracking-tight text-ink">{title}</h1>
        {description ? (
          <>
            <span aria-hidden className="hidden h-4 w-px translate-y-[3px] bg-line-strong sm:block" />
            <p className="min-w-[16rem] flex-1 text-body text-ink-muted">{description}</p>
          </>
        ) : null}
      </div>
      {actions ? <div className="flex items-center gap-2.5">{actions}</div> : null}
    </header>
  )
}
